<form id="informations-client-form" class="px-4" [formGroup]="bienAgricoleForm">
  <div class="d-flex justify-content-between mb-5">
    <div class="col-4">
      <p-input
        [formControl]="bienAgricoleForm.controls.propertyType"
        id="propertyType"
        name="propertyType"
        label="Type de bien"
        [disabled]="true"
      ></p-input>
    </div>

    <div class="col-4">
      <p-input
        [formControl]="bienAgricoleForm.controls.constructionYear"
        id="constructionYear"
        name="constructionYear"
        label="Année de construction"
        [maxLengthNumber]="4"
        (input)="onConstructionYearChanged($event)"
        type="number"
        errorMessage="L'année de construction doit être un nombre à 4 chiffres."
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-select
        id="hasFarmBuildings"
        [items]="yesNoSelectItems"
        [selectedItem]="hasFarmBuildingsItem"
        label="Bâtiments d'exploitation"
        (selected)="onHasFarmBuildingsSelected($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-select
        id="hasResidentialBuilding"
        [items]="yesNoSelectItems"
        [selectedItem]="hasResidentialBuildingItem"
        label="Bâtiment d'habitation"
        (selected)="onHasResidentialBuilding($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="bienAgricoleForm.controls.landAreaHa"
        id="landAreaHa"
        name="landAreaHa"
        label="Surface des terres"
        placeholder="Ex : 10"
        fixedText="Ha"
        type="number"
        (input)="onLandAreaHaChanged($event)"
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-input
        [formControl]="bienAgricoleForm.controls.farmBuildingsAreaM2"
        id="farmBuildingsAreaM2"
        name="farmBuildingsAreaM2"
        label="Surface des bâtiments d'exploitation"
        placeholder="Ex : 1030"
        fixedText="m²"
        type="number"
        (input)="onFarmBuildingsAreaM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="bienAgricoleForm.controls.residentialBuildingsAreaM2"
        id="residentialBuildingsAreaM2"
        name="residentialBuildingsAreaM2"
        label="Surface des bâtiments d'habitation"
        placeholder="Ex : 130"
        fixedText="m²"
        type="number"
        (input)="onResidentialBuildingsAreaM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="bienAgricoleForm.controls.cropType"
        id="cropType"
        name="cropType"
        label="Type de culture"
        placeholder="Ex : Céréales"
        (input)="onCropTypeChanged($event)"
      ></p-input>
    </div>
  </div>
</form>
